import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickZonelessModule } from '@core/directives/zoneless/click/click-zoneless.module';
import { TranslateUiModule } from '@core/translation/translate-ui.module';
import { TranslateModule } from '@ngx-translate/core';
import { ForModule } from '@rx-angular/template/for';
import { IfModule } from '@rx-angular/template/if';
import { LetModule } from '@rx-angular/template/let';
import { PushModule } from '@rx-angular/template/push';
import { ActionsTileComponent } from './actions-tile.component';

@NgModule({
  declarations: [ActionsTileComponent],
  exports: [ActionsTileComponent],
  imports: [
    CommonModule,
    TranslateModule,
    DragDropModule,
    TranslateUiModule,
    ForModule,
    PushModule,
    ClickZonelessModule,
    IfModule,
    LetModule
  ]
})
export class ActionsTileModule {}
